import { useState } from 'react';
import { TextField, Autocomplete, Box, createStyles } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { customStyle } from './CustomAutocompleteStyle';
import { PIXLINK_ADVANCEMENT_STATUS } from 'utils/Constants';

const useStyles = makeStyles(() => createStyles(customStyle));

export const ADVANCEMENT_STATUS_LIST = (t) => [
    { text: t('A commander'), status: PIXLINK_ADVANCEMENT_STATUS.A_COMMANDER },
    { text: t('En cours de rédaction'), status: PIXLINK_ADVANCEMENT_STATUS.EN_COURS_DE_REDACTION },
    { text: t('A valider client'), status: PIXLINK_ADVANCEMENT_STATUS.A_VALIDER_CLIENT },
    { text: t('A valider Netlinking'), status: PIXLINK_ADVANCEMENT_STATUS.A_VALIDER_NETLINKING }, // ✅ nouveau
    { text: t('Validé client, à publier'), status: PIXLINK_ADVANCEMENT_STATUS.VALIDE_CLIENT_A_PUBLIER },
    { text: t('En cours de modification'), status: PIXLINK_ADVANCEMENT_STATUS.EN_COURS_DE_MODIFICATION },
    { text: t('En cours de publication'), status: PIXLINK_ADVANCEMENT_STATUS.EN_COURS_DE_PUBLICATION },
    { text: t('Publié'), status: PIXLINK_ADVANCEMENT_STATUS.PUBLIE },
    { text: t('Refusé éditeur'), status: PIXLINK_ADVANCEMENT_STATUS.REFUSE_EDITEUR },
    { text: t('Spot supplémentaire'), status: PIXLINK_ADVANCEMENT_STATUS.SPOT_SUPPLEMENTAIRE },
];

export const NetlinkingAdvancementStatus = ({
    onListChange,
    highlightedOptions = [],
}) => {
    const { t } = useTranslation();
    const [value, setValue] = useState(null);
    const statusList = ADVANCEMENT_STATUS_LIST(t);

    const handleChange = (event, newValue) => {
        setValue(null);
        onListChange(newValue);
        event.target.value = '';
    };

    return (
        <Autocomplete
            value={value}
            limitTags={0}
            sx={{ '& .MuiAutocomplete-inputRoot': { height: '40px' } }}
            disabled={statusList.length === 0}
            onChange={handleChange}
            options={statusList}
            getOptionLabel={(option) => option.text}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    fullWidth
                    sx={{ height: '40px' }}
                />
            )}
            renderOption={(props, option) => {
                const isHighlighted = highlightedOptions.some(
                    (o) => o.status === option.status
                );
                return (
                    <li
                        {...props}
                        style={{
                            backgroundColor: isHighlighted ? '#ffe426' : 'white',
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box>{option.text}</Box>
                        {isHighlighted && (
                            <img src="Images/icon-check.png" alt="icon-check" />
                        )}
                    </li>
                );
            }}
        />
    );
};